import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {FileManagementService} from '@core/services/file-management.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Router} from '@angular/router';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {DialogService} from "@shared/services/dialog-service";
import {Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';
import {ParticleCacheService} from '@core/services/particle-cache.service';

@Injectable({
  providedIn: 'root'
})
export class ScenarioCalculatorHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  private sourceType: string;

  constructor(private commandService: CommandService,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private dialogService: DialogService,
              private particleCacheService: ParticleCacheService
              ) { }


  destroy(): void {
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    command.projectId = '[PROJECT_ID]';
    this.executeCommandToApi(command);

  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  private handleAction($event): boolean {
    if ($event.action) {
      switch ($event.action?.id) {
        case 'Edit':
          const command = this.magicLinkModel.additionalCommands['UpdateScenarioCalculatorCommand'];
          if (command) {
            const value = $event.item.cells[$event.fieldDefinition.key].value;
            command.fieldValues['FieldKey'] = $event.fieldDefinition.key
            command.fieldValues['CalculatorId'] = $event.item.id;
            command.fieldValues['FieldValue'] = value;
            this.executeCommand(command);
          }
          return true;
        case 'Select':
          const openCountryCalculatorCommand = this.magicLinkModel.additionalCommands['OpenCountryCalculatorCommand'];
          if (openCountryCalculatorCommand) {
            openCountryCalculatorCommand.fieldValues['CalculatorId'] = $event.item.id;
            this.executeCommand(openCountryCalculatorCommand);
          }
          ;
          return true;
        case 'Archive':
        case 'Unarchive':
          this.dialogService.showYesNoDialog(`Confirm ${$event.action.id}`, `Are you sure you want to ${$event.action.id.toString().toLowerCase()} this scenario?`).pipe().subscribe(state => {
            if (state && state.action === 'OK') {
              const command = this.magicLinkModel.additionalCommands['ArchiveScenarioCalculatorCommand'];
              command.fieldValues['IsArchived'] = $event.action.id === 'Archive';
              if (command) {
                command.fieldValues['CalculatorId'] = $event.item.id;
                this.executeCommand(command);
              }
            }
            return true;
          });
          return true;
        default:
          return true;
      }
    }
    return false;
  }

  private handleByFieldDefinition($event): boolean {
    const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
    if (command) {
      command.fieldValues['CalculatorId'] = $event.item.id;
      if ($event.item.cells?.IsSubScenario?.value) {
        command.fieldValues['ReportingEntityCode'] = $event.item.cells?.ReportingEntity?.value;
      }
      this.executeCommand(command);
      return true;
    }
    return false;
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        case 'CommandName':
          return true;
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  valueChanged($event) {
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if (this.handleByFieldDefinition($event)) {
      return;
    }
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[scenario-platform-command] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandToApi(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }

          if (commandResponse.fieldValues['FileId']) {
            const fileId = commandResponse.fieldValues['FileId'];
            const fileName = commandResponse.fieldValues['FileName'];

            this.downloadFile(fileId, fileName);
          }
          if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
            this.magicLinkModelValueChangedHandler({
              id: 'PlatformToolContainerComponent', value: commandResponse.fieldValues['PlatformLinkModel'],
              magicLinkModel: this.magicLinkModel
            });
            return;
          }

          this.invalidateSubject.invalidate();
        },
        error => {
          console.log(error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

}
